import { IconButton } from "@mui/material";
import { DeleteOutline } from "@mui/icons-material";

interface Props {
  onClick: () => void;
  disabled: boolean;
  /** Texto para lectores de pantalla (`"Quitar servicio"`). */
  label: string;
  testId: string;
}

/** Replica `.mp-x`: botón cuadrado de 34px para quitar una tarjeta; en hover toma el color de marca. */
export const ButtonRemove = ({ onClick, disabled, label, testId }: Props) => (
  <IconButton
    aria-label={label}
    onClick={onClick}
    disabled={disabled}
    data-testid={testId}
    sx={{
      width: 34,
      height: 34,
      flexShrink: 0,
      border: "1px solid",
      borderColor: "divider",
      borderRadius: "9px",
      bgcolor: "background.paper",
      color: "tokens.textTertiary",
      "&:hover": {
        bgcolor: "background.paper",
        borderColor: "primary.main",
        color: (theme) => theme.palette.primary.hover ?? theme.palette.primary.main,
      },
      "&.Mui-disabled": { opacity: 0.35 },
    }}
  >
    <DeleteOutline sx={{ fontSize: 16 }} />
  </IconButton>
);
